// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_SalvarInfosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/salvarInfos
 *
 * Updates user profile information in Cognito.
 */
import { registerContract } from './validate'

export interface Usuarios_SalvarInfosInput {
username: string
documento: string
name: string
email: string
phone_number: string
bgcolor?: string
versaoSistema?: string
language?: string
mcp_scopes?: string
dw_scopes?: string
}

registerContract('Usuarios_SalvarInfosInput', {
  username:      { type: 'string',  required: true },
  documento:     { type: 'string',  required: true },
  name:          { type: 'string',  required: true },
  email:         { type: 'string',  required: true },
  phone_number:  { type: 'string',  required: true },
  bgcolor:       { type: 'string',  required: false },
  versaoSistema: { type: 'string',  required: false },
  language:      { type: 'string',  required: false },
  mcp_scopes:    { type: 'string',  required: false },
  dw_scopes:     { type: 'string',  required: false },
})
